// extracted by mini-css-extract-plugin
export default {"section_footer":"FooterSection_section_footer__ACP7t","logout_button":"FooterSection_logout_button__Dcb99","minigame_button":"FooterSection_minigame_button__mKgnU"};